if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.className === 'bss-amo-list-warning-minimum-amount') {
                   let element = document.querySelector(".bss-warning-minimum-amount-title.bss-b2b-translation-amo-warning_minimum_order_text");
                    customizeText(element);
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }, 300);
}

function customizeText(element) {
    if (element) {
        element.textContent = element.textContent.trim().replace(/:/g, "");
    }
}
